// M22: 統計學 - Statistics
// 系統化數據結構，準備 Supabase 後端遷移

export const M22_MODULE_INFO = {
  moduleId: 'M22',
  title: '統計學',
  titleEn: 'Statistics',
  description: '學習統計數據的收集、分析和解釋',
  totalTopics: 8,
  estimatedTime: '10-12小時',
  difficulty: 'intermediate',
  prerequisites: ['M01', 'M21'],
  learningObjectives: [
    '掌握統計數據的描述方法',
    '理解統計圖表的應用',
    '計算中心趨勢和離散程度',
    '進行統計推斷',
    '應用統計解決實際問題'
  ]
};

export const M22_TOPICS = [
  {
    id: 'M22_01',
    name: "數據收集與整理",
    description: "統計數據的收集方法和整理技巧",
    order: 1,
    subTopics: [
      "數據類型的分類",
      "抽樣方法",
      "數據收集技術",
      "數據清理和預處理",
      "數據質量評估"
    ]
  },
  {
    id: 'M22_02',
    name: "統計圖表",
    description: "各種統計圖表的製作和解讀",
    order: 2,
    subTopics: [
      "條形圖和直方圖",
      "圓餅圖和環形圖",
      "散點圖和線圖",
      "箱線圖和莖葉圖",
      "統計圖表的選擇"
    ]
  },
  {
    id: 'M22_03',
    name: "中心趨勢",
    description: "描述數據集中位置的統計量",
    order: 3,
    subTopics: [
      "平均數的計算和性質",
      "中位數的確定方法",
      "眾數的識別",
      "加權平均數",
      "中心趨勢的比較"
    ]
  },
  {
    id: 'M22_04',
    name: "離散程度",
    description: "描述數據分散程度的統計量",
    order: 4,
    subTopics: [
      "極差的計算",
      "四分位數和四分位距",
      "方差和標準差",
      "變異係數",
      "離散程度的解釋"
    ]
  },
  {
    id: 'M22_05',
    name: "相關性分析",
    description: "分析兩個變量之間的關係",
    order: 5,
    subTopics: [
      "散點圖分析",
      "相關係數計算",
      "線性回歸",
      "回歸方程的應用",
      "相關性的解釋"
    ]
  },
  {
    id: 'M22_06',
    name: "概率分布",
    description: "統計中常見的概率分布",
    order: 6,
    subTopics: [
      "正態分布",
      "二項分布",
      "泊松分布",
      "指數分布",
      "分布的參數估計"
    ]
  },
  {
    id: 'M22_07',
    name: "統計推斷",
    description: "從樣本推斷總體的方法",
    order: 7,
    subTopics: [
      "點估計和區間估計",
      "置信區間",
      "假設檢驗",
      "顯著性水平",
      "統計檢驗方法"
    ]
  },
  {
    id: 'M22_08',
    name: "統計應用",
    description: "統計學在各領域的實際應用",
    order: 8,
    subTopics: [
      "質量控制",
      "市場調查分析",
      "醫學統計",
      "社會調查統計",
      "大數據分析入門"
    ]
  }
];

// 導出模組統計信息
export const M22_STATS = {
  totalTopics: M22_TOPICS.length,
  totalSubTopics: M22_TOPICS.reduce((sum, topic) => sum + topic.subTopics.length, 0),
  estimatedHours: 12,
  difficultyLevel: 2, // 1-3 scale
  prerequisiteModules: 2
}; 